/**
 * Configuration for what annotation elements to display/render.
 * This type is shared between the viewer component and download functions
 * to ensure WYSIWYG (What You See Is What You Get) behavior.
 *
 * Designed for extensibility - add new toggle fields as needed.
 */
export interface AnnotationDisplayOptions {
  /** Master toggle for all annotations. When false, shows original image. */
  showAnnotations: boolean;

  /** Toggle for measurement text labels (length, width, mass values). */
  showText: boolean;

  // NOTE: "hide mask, keep keypoints" is intentionally NOT here. This type is the WYSIWYG contract that
  // also drives downloads; the mask toggle is on-screen only, so it lives as a separate `showMask` prop
  // (AnnotatedImageViewer → Segmentation → SegmentationViewer) and must never reach the download path.
  //
  // Future extensibility (would affect both view AND download):
  // showBoundary?: boolean;
  // showKeypoints?: boolean;
  // showSkeleton?: boolean;
}

/** Default display options - annotations and text both visible */
export const DEFAULT_DISPLAY_OPTIONS: AnnotationDisplayOptions = {
  showAnnotations: true,
  showText: true,
};
